import React from 'react'
import Hero from './Hero'
import Courses from './Courses'
import Navbar from './Navbar'
import Footer from './Footer'

const Home = () => {
  return (
    <div className= 'w-full font-outfit'>
      <Navbar/>
      <Hero/>
      <Courses/>
      <Footer/>
    </div>
  )
}

export default Home